function mapVehicleDataSocketToDB(values) {

  const {
    lic: license_plate,
    ts: time,
    dev: device,
    cid: client,
    mod: vehicle_model,
    sta: tempStatus,
    vol: voltage,
    cur: current,
    spe: speed,
    acc: accelerator,
    bra: brakes,
    odo: odometer,
    cv: cell_voltages,
    ct: cell_temperatures,
    ds: door_status,
    ext: extra,
    sig: gprs_signal,
    gac: gps_accuracy,
    dte: device_temperature,
    mode: drive_mode,
    mot: motor_temperature,
    ene: energy,
    hid: hash_id,
    cst: charge_state,
    fsd: free_memory_space,
    sbt: stand_by_time,
    miv: min_cell_voltage,
    mav: max_cell_voltage,
    mit: min_cell_temperature,
    mat: max_cell_temperature,
    at: avg_cell_temperature,
    alt,
    lat,
    lon,
    soc,
  } = values;

  const status = speed && speed > 0 ? 'MOV' : tempStatus;

  return {
    license_plate,
    time,
    device,
    client,
    vehicle_model,
    status,
    voltage,
    current,
    speed,
    accelerator,
    brakes,
    odometer,
    cell_voltages,
    cell_temperatures,
    door_status,
    extra,
    gprs_signal,
    gps_accuracy,
    device_temperature,
    drive_mode,
    motor_temperature,
    energy,
    hash_id,
    charge_state,
    free_memory_space,
    stand_by_time,
    min_cell_voltage,
    max_cell_voltage,
    min_cell_temperature,
    max_cell_temperature,
    avg_cell_temperature,
    alt,
    lat,
    lon,
    soc,
  };

}

export default mapVehicleDataSocketToDB;
